<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <div class='header-container fixed-top'>
            <header class='header navbar navbar-expand-sm'>
                <ul class='navbar-item theme-brand flex-row text-center me-4'>
                    <li class='nav-item theme-logo'>
                        <router-link :to="{ name: 'external_segmented_survey.welcome' }">
                            <img src='@/assets/images/deppes/logo-deppes-white.png' class='navbar-logo' alt='Deppes' />
                        </router-link>
                    </li>
                </ul>
                <div class='d-none horizontal-menu'>
                    <a href='javascript:void(0);' class='sidebarCollapse' data-placement='bottom'
                       @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            class='feather feather-menu'
                        >
                            <line x1='3' y1='12' x2='21' y2='12'></line>
                            <line x1='3' y1='6' x2='21' y2='6'></line>
                            <line x1='3' y1='18' x2='21' y2='18'></line>
                        </svg>
                    </a>
                </div>
                <div class='navbar-item flex-row ms-md-auto'>
                    <div class='text-white fs-6 d-none d-sm-flex align-items-center '>
                        <b> {{ company?.name }}</b>
                    </div>
                    <div class='dropdown nav-item user-profile-dropdown btn-group'>
                        <a href='javascript:;' id='ddluser' data-bs-toggle='dropdown' aria-expanded='false'
                           class='btn dropdown-toggle btn-icon-only user nav-link'>
                            <img
                                :src='`https://ui-avatars.com/api/?name=${company?.name}&color=0e1726&background=fff&bold=true`'
                                alt='avatar' class='rounded-circle' />
                        </a>
                        <ul class='dropdown-menu dropdown-menu-right' aria-labelledby='ddluser'>
                            <li role='presentation'>
                                <a href='javascript:;' @click.prevent='logout' class='dropdown-item'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='24'
                                        height='24'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='currentColor'
                                        stroke-width='2'
                                        stroke-linecap='round'
                                        stroke-linejoin='round'
                                        class='feather feather-log-out'
                                    >
                                        <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'></path>
                                        <polyline points='16 17 21 12 16 7'></polyline>
                                        <line x1='21' y1='12' x2='9' y2='12'></line>
                                    </svg>
                                    Logout
                                </a>
                                <a href='javascript:;' @click.prevent='openSettings' class='dropdown-item'>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-user"
                                    >
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                    Perfil
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </div>
        <!--  END NAVBAR  -->

        <!--  BEGIN NAVBAR  -->
        <div class='sub-header-container'>
            <header class='header navbar navbar-expand-sm'>
                <!--a href='javascript:void(0);' class='sidebarCollapse' data-placement='bottom'
                   @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        stroke-width='2'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                        class='feather feather-menu'
                    >
                        <line x1='3' y1='12' x2='21' y2='12'></line>
                        <line x1='3' y1='6' x2='21' y2='6'></line>
                        <line x1='3' y1='18' x2='21' y2='18'></line>
                    </svg>
                </a-->
                <div id='breadcrumb' class='vue-portal-target ms-3'></div>
            </header>
        </div>
        <!--  END NAVBAR  -->
    </div>
</template>

<script setup>
    import { computed, onMounted, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { useStore } from 'vuex';
    
    const store = useStore();
    const selectedLang = ref(null);
    const i18n = useI18n();
    const company = computed(() => store.state.segmentedSurveyCompany.company);
    
    const toggleMode = (mode) => {
        window.$appSetting.toggleMode(mode);
    };
    
    const logout = () => {
        store.dispatch('segmentedSurveyCompany/logout');
    };
    
    const openSettings = () => {
        store.commit('segmentedSurveyCompany/openModalUpdate');
    }

    onMounted(() => {
        selectedLang.value = window.$appSetting.toggleLanguage();
        toggleMode();
    });
</script>
